export const Config = {
  main_url: 'https://nursing-api.stlordsinternationalpublicschool.com',
  mainpy_url: "https://python.stlordsinternationalpublicschool.com",
};
